import * as angular from 'angular';

export class CompaniesFactory {
    private apiRoot: string = '/api/v1/companies';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    readCompanies(id: string) {
        return this.$http.get(`${this.apiRoot}/${id}/`);
    }

    readHousingAssociations(id: string, params: any) {
        return this.$http.get(`/api/v2/customers/`, { params });
    }

    readOneHa(haId: string) {
        return this.$http.get(`/api/v2/customers/${haId}/`);
    }

    readEmployees(id: string, params: any) {
        return this.$http.get(`/api/v2/employees/`, { params });
    }

    createIssue(id: string, data: any) {
        return this.$http.post(`${this.apiRoot}/${id}/issues/`, data);
    }

    readIssueReport(id: string, params: any) {
        return this.$http.get(`${this.apiRoot}/${id}/issue_report/`, {
            params,
        });
    }

    readIssueReportGroup(id: string, params: any) {
        return this.$http.get(`${this.apiRoot}/${id}/issue_report_group/`, {
            params,
        });
    }

    addAdditionallyAssignedTo(compId: string, issueId: string, value: any) {
        return this.$http.post(
            `${this.apiRoot}/${compId}/issues/${issueId}/additionally_assigned_to/`,
            value
        );
    }

    removeAdditionallyAssignedTo(
        compId: string,
        issueId: string,
        userId: string
    ) {
        return this.$http.delete(
            `${this.apiRoot}/${compId}/issues/${issueId}/additionally_assigned_to/${userId}/`
        );
    }

    downloadIssuePrintout(companyId: string, issueId: string) {
        const params = { id__in: issueId };
        return this.$http.get(
            `${this.apiRoot}/${companyId}/issues/download_issue_printout/`,
            { responseType: 'arraybuffer', params }
        );
    }

    downloadJobPrintout(companyId: string, issueId: string) {
        const params = { id__in: issueId };
        return this.$http.get(
            `${this.apiRoot}/${companyId}/issues/download_job_printout/`,
            { responseType: 'arraybuffer', params }
        );
    }

    bulkChangeStatus(
        compId: number,
        status: string,
        issueIds: number[],
        assignee: { userId: number } = null
    ) {
        const payload: any = { status: status, issues: issueIds };
        if (assignee) {
            payload.assignee_user_id = assignee.userId;
        }
        return this.$http.post(
            `${this.apiRoot}/${compId}/issues/bulk_change_status/`,
            payload
        );
    }

    readAuthorData(comp_id: string, issue_id: string) {
        return this.$http.get(
            `${this.apiRoot}/${comp_id}/issues/${issue_id}/author_data/`
        );
    }

    editIssue(comp_id: string, issue_id: string, value: any) {
        return this.$http.patch(
            `${this.apiRoot}/${comp_id}/issues/${issue_id}/`,
            value
        );
    }

    getCustomFields(compId: string, params: any) {
        return this.$http.get(`${this.apiRoot}/${compId}/custom_fields/`, {
            params,
        });
    }

    assignMe(comp_id: string, issue_id: string) {
        return this.$http.put(
            `${this.apiRoot}/${comp_id}/issues/${issue_id}/assign_me/`
        );
    }

    readJournal(comp_id: string, issue_id: string, params: any) {
        return this.$http.get(
            `${this.apiRoot}/${comp_id}/issues/${issue_id}/journals/`,
            { params }
        );
    }

    addToJournal(comp_id: string, issue_id: string, value: any) {
        return this.$http.post(
            `${this.apiRoot}/${comp_id}/issues/${issue_id}/journals/`,
            value
        );
    }

    downloadView(comp_id: string, params: any) {
        return this.$http.get(`${this.apiRoot}/${comp_id}/issues/export/`, {
            params: params,
            responseType: 'arraybuffer',
        });
    }

    getLocations(params: any) {
        return this.$http.get('/api/v1/assets/', { params });
    }

    reassignClient(companyId: string, issueId: string, client: any) {
        return this.$http.post(
            `${this.apiRoot}/${companyId}/issues/${issueId}/reassign_client/`,
            client
        );
    }

    readIssues(id: string, params: any) {
        return this.$http.get(`${this.apiRoot}/${id}/issues/`, { params });
    }

    readOneIssue(comp_id: string, issue_id: string) {
        return this.$http.get(`${this.apiRoot}/${comp_id}/issues/${issue_id}/`);
    }
}

angular.module('app').service('CompaniesFactory', CompaniesFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/companies.factory.ts